
const Message = ({ oldChat, colorData }) => {
  return (
    <>
    {
      !oldChat ? <h3 style={{ textAlign: 'center', marginTop: '20%', color: 'gray' }}>No Conversation Selected</h3> : oldChat?.length < 1 ? (
          <span>No data found</span>
        ) : 
      <>
      {
        oldChat?.map(function(item, index){
          return <>
             <div className="message owner" key={index} style={{ 
             alignSelf: item.author_type === "Provider" ? "flex-start" : "flex-end"
             }}>
                <div className="messageContent" style={{ marginTop: '3px', 
                backgroundColor: item.author_type === "Provider" ? colorData : "#8da4f1" }}>
                <span style={{ fontSize: '12px', alignSelf: 'flex-end'}}>{item.date_created.slice(0, 22)}</span>
                  {
                    item.body ? <>
                    <p style={{ backgroundColor: item.author_type === "Provider" ? colorData : "#8da4f1" }}>{item.body}</p>
                    </> : null
                  }
                  {
                 item.media_url_list?.map((data) => {
                   return <img 
                      src={data} 
                      alt="" 
                    />
                 })
               }
                </div>
            </div>
          </>
        })
      }
      </>
    }
    
    
    </>
  )
}

export default Message